import { useState } from "react";
import { CardMarketCardTraderSwitch } from "../../components/CardMarketCardTraderSwitch/CardMarketCardTraderSwitch";
import { Box, FlexBox } from "../../components/primitives";
import { Title } from "../LoginPage/loginPage.styled";
import { PrimaryButton } from "../../components/common/common.style";
import { ModalCreateStrategyCardMarket } from "../../components/PriceStrategyPage/ModalCreateStrategyCardMarket/ModalCreateStrategyCardMarket";
import { ModalCreateStrategyCardTrader } from "../../components/PriceStrategyPage/ModalCreateStrategyCardTrader/ModalCreateStrategyCardTrader";
import {
  useDeletePriceStrategyCardMarketMutation,
  useDeletePriceStrategyCardTraderMutation,
  useGetAllCardMarketPriceStrategyQuery,
  useGetAllCardTraderPriceStrategyQuery,
} from "../../services/myServer/priceStrategy";
import { StrategyCard } from "../../components/StrategyCard/StrategyCard";

export const PriceStrategyPage = () => {
  const [strategyType, setStrategyType] = useState<"cardtrader" | "cardmarket">(
    "cardtrader"
  );
  const [isOpenModalCtCreateStrategy, setIsOpenCtModalCreateStrategy] =
    useState(false);
  const [isOpenModalCmCreateStrategy, setIsOpenModalCmCreateStrategy] =
    useState(false);
  const { data: cardtraderStategy, refetch: refetchCardtrader } =
    useGetAllCardTraderPriceStrategyQuery();
  const { data: cardmarketStategy, refetch: refetchCardMarket } =
    useGetAllCardMarketPriceStrategyQuery();
  const [deletePriceStrategyCardTrader] =
    useDeletePriceStrategyCardTraderMutation();
  const [deletePriceStrategyCardMarket] =
    useDeletePriceStrategyCardMarketMutation();

  const onDeleteCardTraderHandler = async (id: number) => {
    await deletePriceStrategyCardTrader({ strategyId: id });
    refetchCardtrader();
  };

  const onDeleteCardMarketHanlder = async (id: number) => {
    await deletePriceStrategyCardMarket({ strategyId: id });
    refetchCardMarket();
  };

  return (
    <>
      {isOpenModalCtCreateStrategy && (
        <ModalCreateStrategyCardTrader
          setIsOpenModalCreateStrategyPrice={setIsOpenCtModalCreateStrategy}
          refetch={refetchCardtrader}
        />
      )}
      {isOpenModalCmCreateStrategy && (
        <ModalCreateStrategyCardMarket
          setIsOpenModalCreateStrategyPrice={setIsOpenModalCmCreateStrategy}
          refetch={refetchCardMarket}
        />
      )}
      <Box css={{ minHeight: "100vh", backgroundColor: "#f0fdf4" }}>
        <Box css={{ paddingTop: 40 }}>
          <Title>My Pricing Strategy</Title>
          <Box
            css={{
              width: 600,
              maxWidth: "100%",
              margin: "20px auto",
              textAlign: "center",
            }}
          >
            A Pricing Strategy is an automated rule that determines how your
            cards are priced. You can choose to base your strategy on: Market
            Competition, automatically adjust prices based on what similar
            sellers are offering. This helps keep your listings competitive
            without manual updates.
          </Box>
          <CardMarketCardTraderSwitch
            selected={strategyType}
            setSelected={setStrategyType}
          />
          <FlexBox css={{ justifyContent: "center", marginTop: 20 }}>
            <PrimaryButton
              onClick={() => {
                if (strategyType === "cardmarket") {
                  setIsOpenModalCmCreateStrategy(true);
                } else {
                  setIsOpenCtModalCreateStrategy(true);
                }
              }}
            >
              CREATE NEW STRATEGY
            </PrimaryButton>
          </FlexBox>
          <Box css={{ padding: "20px" }}>
            {cardtraderStategy?.length && strategyType === "cardtrader" ? (
              <FlexBox css={{ gap: 20, flexWrap: "wrap" }}>
                {cardtraderStategy.map((strategy) => (
                  <StrategyCard
                    {...strategy}
                    onDelete={(id) => onDeleteCardTraderHandler(id)}
                  />
                ))}
              </FlexBox>
            ) : null}
            {cardmarketStategy?.length && strategyType === "cardmarket" ? (
              <FlexBox css={{ gap: 20, flexWrap: "wrap" }}>
                {cardmarketStategy.map((strategy) => (
                  <StrategyCard
                    {...strategy}
                    onDelete={(id) => onDeleteCardMarketHanlder(id)}
                  />
                ))}
              </FlexBox>
            ) : null}
          </Box>
        </Box>
      </Box>
    </>
  );
};
